import { StringTemplateKeyPrefix } from '@seo/const';

/**
 * Мапи данные в переменные шаблона.
 *
 * Пример имеем объект: `const city = { name: 'Тюмень', code: 'tmn' }`
 * mapDataToTemplateVariables(city, 'someCity')
 * получим объект: `{ 'someCity.name': 'Тюмень', 'someCity.code': 'tmn' }`
 * который можно использовать для передачи в StringTemplate.resolve(): `${ someCity.name }`
 *
 * @param data
 * @param keyPrefix
 * @returns
 */
export function mapDataToTemplateVariables<T extends Record<string | number, unknown>>(
  data: T,
  keyPrefix: StringTemplateKeyPrefix,
): Record<`${typeof keyPrefix}.${Extract<keyof T, string | number>}`, T[keyof T]> {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => {
      return [`${keyPrefix}.${key}`, value];
    }),
  ) as Record<`${typeof keyPrefix}.${Extract<keyof T, string | number>}`, T[keyof T]>;
}
